import React from "react";

const PersonalInfo = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4577_24353)">
      <path
        d="M10 9.16601C12.0711 9.16601 13.75 7.48708 13.75 5.41602C13.75 3.34495 12.0711 1.66602 10 1.66602C7.92893 1.66602 6.25 3.34495 6.25 5.41602C6.25 7.48708 7.92893 9.16601 10 9.16601Z"
        stroke="currentColor"
        strokeWidth="1.40351"
        strokeLinejoin="round"
      />
      <path
        d="M2.08374 18.3335C2.08374 14.8179 4.65666 11.5366 6.83374 10.8335C6.83374 10.8335 8.81291 12.9429 10.0004 14.3491L13.1671 10.8335C14.9483 11.0679 17.9171 14.8179 17.9171 18.3335"
        stroke="currentColor"
        strokeWidth="1.40351"
        strokeLinejoin="round"
      />
      <path
        d="M0.83374 18.3335H19.1671"
        stroke="currentColor"
        strokeWidth="1.40351"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4577_24353">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default React.memo(PersonalInfo);
